<template>
    <div class="modal fade" id="category-create-modal-category" tabindex="-1" aria-labelledby="category-create-modal-category" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{$t('categories')}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                </div>
                <div class="modal-body" style="text-align:left">
                    <div class="mb-3">
                        <label for="exampleFormControlInput1" class="form-label">{{$t('name')}}</label>
                        <input v-model="category.name" type="string" class="form-control" id="exampleFormControlInput1" :placeholder="$t('category')">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                    <button type="button" class="btn btn-success" :disabled="loading || category.name.length < 2"  @click="save"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('create')}}</button>
                </div>
                </div>
            </div>
        </div>
</template>

<script>
import helper from '../helper'
export default {
  name: 'CategoryCompo',
  props : ['state'],
  data(){
    return {
        search : '',
        categories : [],
        category : {
            id : null,
            name : '',
        },
        createCategoryModal : null,
        loading : false
    }
  },
  mounted(){
    // eslint-disable-next-line no-undef
    this.createCategoryModal = new bootstrap.Modal(document.getElementById('category-create-modal-category'))
    if(this.state === true){
       this.createCategoryModal.show()
    }

    document.getElementById('category-create-modal-category').addEventListener('hidden.bs.modal', () => { 
        this.$emit('createCategory',{state : false })
    })

  },
  methods : {
    create(){
        this.clearForm()

        // eslint-disable-next-line no-undef
        this.createCategoryModal.show()
    },
    async save(){
        try{
            this.loading = true
            const response = await helper.customPost(`${process.env.VUE_APP_API}/categories`,this.category,{showToast:true})
            this.loading = false
            this.clearForm()
            this.$emit('createCategory',{category : response.data, state : false })
            this.createCategoryModal.hide()
        }catch(error){
            this.loading = false
        }

    },
    clearForm(){
        this.category = {
            id : null,
            name : ''
        }
    },
    //helper functions
    formatDate(date) { return helper.formatDate(date) }
  }
}
</script>
